import B2BDashboard from "@/pages/b2b_dashboard";
import B2BReport from "@/pages/b2b_report";

const URL_MAPPING = {
  LOGIN: "/auth/login",
  SIGNUP: "/auth/verifymail",
  FORGETPASS: "/forget-pass",
  LOGIN_ROOT: "/",
  TEST: "test",
  ANALYTICS: "/analytics",
  SALESMAN: "/map-view",
  CUSTOMERLIST: "/customer-list",
  TERRITORIES: "/territories",
  DASHBOARD: "/dashboard",
  CUSTOMERLISTDETAILS: "/customer-list-details",
  LANDING: "/home",
  RESETPASS: "/reset-password",
  SDRDASHBOARD: "/sdr-dashboard",
  CALLPLANREPORT: "/call-plan-report",
  GOOGLEAUTH: "/auth/verfiy-qr",
  EMPLOYEETABLE: "/employee-table",
  MASTERLIST: "/master-list",
  AGINGREPORT: "/aging-report",
  ACTIVITYREPORT: "/activity-report",
  HORECACOLLECTIONREPORT: "/horeca-collection-report",
  HORECASTOCKREPORT: "/horeca-stock-report",
  CUSTOMERVISITSREPORT: "/customer-visits-report",
  DASHBOARDZAMZAM: '/inventory',
  RESETTRIP: "/reset-trip",
  PLANOGRAM: "/planogram",
  NOTIFICATIONS: "/notifications",
  VISITREPORT: "/visit-report",
  VIDEO_VIEW_REPORT: "/video-view-report",
  DEPOSITREPORT: "/deposit-report",
  SALESREPORT: "/sales-report",
  INVOICEREPORT: "/invoice-report",
  MAPVIEW: "/map-view-updated",
  KAKRREPORT: "/kakr-report",
  DELIVERYDASHBOARD: "/delivery-dashboard",
  DELIVERYREPORT: "/delivery-report",
  DELIVERYIMAGESREPORT: "/delivery-images-report",
  PLANNINGREPORT: "/planning-report",
  OTPCHECKINREPORT: "/otp-checkin-report",
  INVENTORY: "/inventory",
  CREATEORDER: "/create-order",
  ORDERHISTORY: "/order-history",
  MANAGEADDR: "/manage-addr",
  FINANCE: '/finance',
  DELIVERYSUMMARYREPORT: "/delivery-summary-report",
  RESCHEDULEDDELIVERYREPORT: "/rescheduled-delivery-report",
  STOCKREPORT: "/kakr-stock-report",
  SURVEY: 'Survey',
  DYNAMIC: 'dynamic',
  REJECTIONREPORT: '/rejection-report',
  SUPERVISORACTIVITYREPORT: '/supervisor-activity-report',
  SUPERVISORDASHBOARD: '/supervisor-dashboard',
  SUPERVISORCOLLECTIONAUDIT: '/supervisor-collection-audit',
  SUPERVISORCUSTOMERCREATION: '/customer-creation-report',
  SUPERVISORLOCATIONCAPTURE: '/location-capture-report',
  SUPERVISORVISITREPORT: '/supervisor-visit-report',
  SUPERVISORPOREPORT: '/po-report',
  B2BREPORT: '/b2b-report',
  SFAFEEDBACKCUSTOMERREPORT: '/sfa-customer-feedback-report',
  TERRITORYMAPVIEW: '/territory-map-view',
  ASSIGNLMDTERRITORY: '/assign-lmd-territory',
  LMDTERRITORY: '/lmd-territory',
  B2BFEEDBACKREPORT: '/b2b-feedback-report',
  SHOPLICENSEREPORT: '/shop-license-report',
  B2BDASHBOARD: '/b2b-dashboard',
  SUPERVISORCOLLECTIONREPORT: '/collection-report',
  SUPERVISORMAP: '/supervisor-map',
  SDRACTIVITYREPORT: '/sdr-activity-report',
  SDRACTIVITYREPORT40: '/sdr-activity-report-40',

  SDRVISITREPORT: '/sdr-visit-report',
  HORECAVISITREPORT: '/horeca-visit-report',
  HORECAACTIVITYREPORT: '/horeca-activity-report',
  HORECAQUATERLYCONFIRMATIONREPORT: '/horeca-quaterly-confirmation-report',
  SDRSUMMARYREPORT: '/sdr-summary-report',
  ADMINPANEL: '/employees',
  CUSTOMERS: '/customers',
  EDITEMPLOYEE: (id: string) => `/employees/${id}`,
  EDITCUSTOMER: (id: string) => `/customers/${id}`,
  OFFERS: '/offers',
  ADDNEWOFFERS: '/offers-add-new',
  EDITOFFER: (id: string) => `/edit-offer/${id}`,
  STORAGEMAPPING: '/storage-mapping',
  CREATESTOREAGEMAPPING: '/storage-create',
  VIEWSTORAGEMAPPING: (id: string) => `/view-storage/${id}`,
  MEDIA: '/media',
  ADDNEWMEDIA: '/media-add',
  EDITMEDIA: (id: string) => `/edit-media/${id}`,
  TRAININGVIDEOS: '/training-videos',
  ADDTRAININGVIDEO: '/training-videos-add',
  EDITTRAININGVIDEO: (id: string) => `/edit-training-video/${id}`,
  TERRITORY: '/territory',
  ADDNEWTERRITORY: '/territory-add',
  CREATEDUMMYTERRITORY: '/create-territory',
  ADDSALES: '/sales-add',
  EDITTERRITORY: (id: string) => `/territory/${id}`,
  EDITPERM: (id: string) => `/roles-edit-permissions/${id}`,
  EMPLOYEEMONTHLY: '/employee-monthly-target',
  EDITMONTHLY: (id: string) => `/employee-monthly-target-edit/${id}`,
  ADDNEWMONTHLYTARGET: '/employee-add',
  UPLOADMONTHLY: '/employee-upload-monthly',
  CONFIG: '/config',
  EDITCONFIG: (id: string) => `/config-edit/${id}`,
  ADDCONFIG: '/config-add',
  ACTIVATION: '/activation',
  REPORT: '/report',
  ADDREPORT: '/report-add',
  NOTIF: '/notification',
  MASTERSYNC: '/master-sync',
  AUTH: '/roles',
  ROLE_EMPLOYEE: '/employee-roles',
  ROLEPERMISSION: "/role-permissions",
  SALES: '/sales',
  ROADNET: '/roadnet',
  ROUTE_PLANNING_GENERATE: '/roadnet-route-planning-generate',
  TARGETKPI: '/target-kpi',
  EDITSALES: (id: string) => `/sales-edit/${id}`,
  EDITORDERHISTORY: (id: string) => `/edit-order-history/${id}`,

  ADDRULES: '/roles-add',
  ADDPERMISSIONS: (id: string) => `/roles-permissions/${id}`,
  ASSIGNROLE: (id: string) => `/roles-assign/${id}`,
  OTPGENERATION: '/otp-generation',
  DELIVERYHEATMAP: '/delivery-heatmap',
  /** Public delivery pin-drop (open link with `?token=` query). */
  UPDATE_LOCATION: '/update-location',
};

/** External Power BI analytical dashboard (opens in new tab). */
export const ANALYTICAL_TOOL_URL =
  "https://app.powerbi.com/groups/me/apps/a451194a-6849-4792-b78b-b4d92d886ab0/reports/4cb2768f-1e4c-497c-b728-292bd059e5d3/d078d47b7429d8c19e75?ctid=4ca4c6ea-0988-4747-a108-8c66f825a2e9&pbi_source=appShareLink&portalSessionId=3f2cf98e-a6a1-4f4e-ac6c-a1c5082c5b93";

/** External Employee Portal (SAP SuccessFactors). */
export const EMPLOYEE_PORTAL_URL =
  "https://performancemanager.successfactors.eu/login?company=beraincomp#/login";

/** External Internal FIORI portal (SAP). */
export const INTERNAL_FIORI_URL = "https://prd.berain.com.sa/sap/bc/ui2/flp";

export default URL_MAPPING;